var CouponItemDto = (function () {
    function CouponItemDto(code, id, statusCode, valid, calloutMessage) {
        if (code === void 0) { code = ''; }
        if (id === void 0) { id = ''; }
        if (statusCode === void 0) { statusCode = ''; }
        if (valid === void 0) { valid = true; }
        if (calloutMessage === void 0) { calloutMessage = []; }
        this.code = code;
        this.id = id;
        this.statusCode = statusCode;
        this.valid = valid;
        this.calloutMessage = calloutMessage;
    }
    CouponItemDto.fromOcapi = function (ocapiCouponItems) {
        return new CouponItemDto(ocapiCouponItems.code, ocapiCouponItems.coupon_item_id, ocapiCouponItems.status_code, ocapiCouponItems.valid, ocapiCouponItems.c_calloutMessages);
    };
    return CouponItemDto;
}());
export { CouponItemDto };
//# sourceMappingURL=CouponItemDto.js.map